module.exports = __webpack_public_path__ + "static/media/stateoverview.5c42a2cd.svg";